function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.5,82.5,48.7,81.51a7.871,7.871,0,0,1-1.389-7.392H17a17,17,0,0,1-17-17V17A17,17,0,0,1,17,0H94.489a17,17,0,0,1,17,17V57.118a17,17,0,0,1-17,17H64.175a7.871,7.871,0,0,1-1.389,7.392l-.795.993a8,8,0,0,1-12.494,0Z",
  fill: "none",
  stroke: "#205da8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.678,87.384,21.066,74.119H17a17,17,0,0,1-17-17V17A17,17,0,0,1,17,0H94.489a17,17,0,0,1,17,17V57.118a17,17,0,0,1-17,17H46.976L36.364,87.384a3,3,0,0,1-4.685,0Z",
  fill: "none",
  stroke: "#205da8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1064.983 -386.864)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M186.083.237c91.2-19.191,185.877,120.245,129.763,188.087s-77.24,158.4-144.14,152.115S0,266.747,0,171.926C-.809,34.78,129.805,29.169,186.083.237Z",
  transform: "translate(1064.986 408.382)",
  fill: "#ebebeb"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1271.883 386.864)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-10005.394-12060.627s5.862-11.6,14.141-12.356,78.925-1.442,82.554,0,11.209,7.492,11.356,13.642,0,40.327,0,40.327l-24.517-1.2-65.439-18.437Z",
  transform: "translate(10006.868 12074.492)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-9943.933-12118.436s-4.413-37.412-6.407-42.723,1.146-15.6-17.422-19.055-42.488-1.424-52.949-2.379-26.838-6.029-30.331-5.318-7.69,27.734-1.443,42.549,67.953,34.922,86.391,32.871S-9943.933-12118.436-9943.933-12118.436Z",
  transform: "translate(10055.479 12190.165)",
  fill: "#c4dcf9"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-10090.772-12193.18s3.737,54.465,24.233,60.918,54.5,1.26,76.7,11.166-27.258,25.811-41.7,22.609-49.429-4.131-57.906-6.314-24.856-33.037-21.618-49.83S-10090.772-12193.18-10090.772-12193.18Z",
  transform: "translate(10093.887 12193.746)",
  fill: "#75abe0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)",
  fill: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M31.678,87.384,21.066,74.119H17a17,17,0,0,1-17-17V17A17,17,0,0,1,17,0H94.489a17,17,0,0,1,17,17V57.118a17,17,0,0,1-17,17H46.976L36.364,87.384a3,3,0,0,1-4.685,0Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 34.0210075378418 85.50960540771484 C 34.02101135253906 85.50959777832031 34.02101516723633 85.50959014892578 34.02101898193359 85.50958251953125 L 44.6334342956543 72.24448394775391 C 45.20275115966797 71.53285217285156 46.0646858215332 71.11859893798828 46.97601699829102 71.11859893798828 L 94.48920440673828 71.11859893798828 C 98.22861480712891 71.11859893798828 101.7441482543945 69.662353515625 104.3881988525391 67.01810455322266 C 107.0322494506836 64.37387084960938 108.4884033203125 60.85811996459961 108.4884033203125 57.11850357055664 L 108.4884033203125 17.00010299682617 C 108.4884033203125 13.26048564910889 107.0322494506836 9.744735717773438 104.3881988525391 7.100502490997314 C 101.7441482543945 4.456252574920654 98.22861480712891 3.00000262260437 94.48920440673828 3.00000262260437 L 17.00010108947754 3.00000262260437 C 13.26058483123779 3.00000262260437 9.744868278503418 4.456285953521729 7.100568294525146 7.100569248199463 C 4.456284999847412 9.744869232177734 3.000001668930054 13.26058578491211 3.000001668930054 17.00010299682617 L 3.000001668930054 57.11850357055664 C 3.000001668930054 60.8580207824707 4.456284999847412 64.37373352050781 7.100568294525146 67.01803588867188 C 9.744868278503418 69.66232299804688 13.26058483123779 71.11859893798828 17.00010108947754 71.11859893798828 L 21.0657844543457 71.11859893798828 C 21.97711753845215 71.11859893798828 22.83905220031738 71.53285217285156 23.40836906433105 72.24448394775391 L 34.02040100097656 85.50910186767578 C 34.02053833007812 85.50926971435547 34.02066802978516 85.50943756103516 34.02080154418945 85.50959777832031 C 34.02087020874023 85.50959777832031 34.02093505859375 85.50959777832031 34.0210075378418 85.50960540771484 M 34.02123641967773 88.50960540771484 C 33.15015029907227 88.50960540771484 32.27895355224609 88.13430023193359 31.67820167541504 87.38370513916016 L 21.0657844543457 74.11859893798828 L 17.00010108947754 74.11859893798828 C 7.611301422119141 74.11859893798828 1.660156272009772e-06 66.50730133056641 1.660156272009772e-06 57.11850357055664 L 1.660156272009772e-06 17.00010299682617 C 1.660156272009772e-06 7.611302852630615 7.611301422119141 2.703857489905204e-06 17.00010108947754 2.703857489905204e-06 L 94.48920440673828 2.703857489905204e-06 C 103.8779983520508 2.703857489905204e-06 111.4884033203125 7.611302852630615 111.4884033203125 17.00010299682617 L 111.4884033203125 57.11850357055664 C 111.4884033203125 66.50730133056641 103.8779983520508 74.11859893798828 94.48920440673828 74.11859893798828 L 46.97601699829102 74.11859893798828 L 36.36360168457031 87.38370513916016 C 35.76330184936523 88.13430023193359 34.892333984375 88.50960540771484 34.02123641967773 88.50960540771484 Z",
  stroke: "none",
  fill: "#205da8"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(-451.618 -37.074)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(1668.618 493.074)",
  fill: "rgba(32,93,168,0)",
  stroke: "#3a76c4",
  strokeWidth: 8
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.5,
  cy: 24,
  rx: 24.5,
  ry: 24,
  stroke: "none"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 24.5,
  cy: 24,
  rx: 20.5,
  ry: 20,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  d: "M7353.43,1583.967l-15.5,73.51,30.236,27.89,31.134,53.675h-31.134l-26.937-45.446-42.027-33.034,8.43-53.783-23.481,11.353v24.1h-23.2v-41.35l23.2-10.693,29.5-13.6Z",
  transform: "translate(-5649.207 -1029.468)",
  fill: "rgba(32,93,168,0)",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M7304.993,1647.01l-13,26.592-46.416-21.017-11.728,22.817,71.142,34.786,25.612-43.874Z",
  transform: "translate(-5655 -1014.411)",
  fill: "#b5c7df",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
}), /*#__PURE__*/React.createElement("path", {
  d: "M7339.009,1583.388l18.1,22.971,20.911-15.351,12.037,19.281-35.342,25.032-22.027-25.032Z",
  transform: "translate(-5633.869 -1028.013)",
  fill: "#b5c7df",
  stroke: "#3a76c4",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1288.336 386.864)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 80,
  height: 79,
  transform: "translate(-0.336 0.136)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(5.301 16.807)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.925,38.7A19.161,19.161,0,0,1,0,32.771a23.225,23.225,0,0,0,2.053-3.508,15.48,15.48,0,1,0,0-19.828A23.254,23.254,0,0,0,0,5.928,19.161,19.161,0,0,1,13.925,0a19.35,19.35,0,1,1,0,38.7Z",
  transform: "translate(38.301 0.001)",
  fill: "#205da8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.331,2A19.35,19.35,0,1,0,40.7,21.35,19.341,19.341,0,0,0,21.331,2Zm.019,34.83A15.48,15.48,0,1,1,36.83,21.35,15.476,15.476,0,0,1,21.35,36.83Zm.968-25.155h-2.9v11.61l10.159,6.1L31.025,27l-8.708-5.167Z",
  transform: "translate(-2 -2)",
  fill: "#205da8"
})), /*#__PURE__*/React.createElement("path", {
  d: "M16.408,0A16.408,16.408,0,1,1,0,16.408,16.408,16.408,0,0,1,16.408,0Z",
  transform: "translate(2.983 2.983)",
  fill: "#205da8",
  opacity: 0.3
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.912,18.221c-2.224,0-3.1-.993-3.217-2.267H6.32c.13,2.364,1.9,3.692,3.972,4.134v2.342h3.238V20.11c2.1-.4,3.778-1.619,3.778-3.832,0-3.066-2.623-4.113-5.074-4.75S9,10.232,9,9.207c0-1.177,1.09-2,2.915-2,1.921,0,2.634.918,2.7,2.267H17a4.3,4.3,0,0,0-3.465-4.113V3H10.292V5.332c-2.094.453-3.778,1.814-3.778,3.9,0,2.494,2.062,3.735,5.074,4.458,2.7.648,3.238,1.6,3.238,2.6,0,.745-.529,1.932-2.915,1.932Z",
  transform: "translate(40.665 5.95)",
  fill: "#205da8"
}))));

var SvgActiveEmptyStateIcon = function SvgActiveEmptyStateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 332.68,
    height: 362.268,
    viewBox: "0 0 332.68 362.268",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgActiveEmptyStateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ActiveEmptyStateIcon.683d4253.svg";
export { ForwardRef as ReactComponent };